import styled from "styled-components";

interface IProps {
  hidden?: boolean;
}

export const ContentCards = styled.div<IProps>`
  display: ${(props: IProps) => (props.hidden ? "none" : "flex")};
  justify-content: flex-start;
  align-items: baseline;
  border: 1px solid rgb(213, 213, 213);
  padding: 10px;
  border-radius: 10px;
  width: 100%;
  flex-wrap: wrap;
`;

export const ContainerCards = styled.div<IProps>`
  display: ${(props: IProps) => (props.hidden ? "none" : "flex")};
  justify-content: center;
  border: 2px solid rgb(213, 213, 213);
  flex-direction: column;
  padding: 10px;
  border-radius: 10px;
  align-items: flex-start;
  gap: 10px;
  margin-bottom: 10px;
`;

export const ContainerAction = styled.div<IProps>`
  display: ${(props: IProps) => (props.hidden ? "none" : "flex")};
  align-items: center;
  border: 2px solid rgb(213, 213, 213);
  justify-content: space-between;
  padding: 10px;
  border-radius: 10px;
`;
